import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Switch from "react-switch";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, generatePDF, VehicleCategoryRegex } from "../../commonClass/CommonValidation";
import { getAllData, postUsersData, verifytoken } from "../../../services/ApiCallingUserServices";
import { loaderActions } from "../../../_actions/loader.actions";
import { ClearLocalStorage } from "../../commonClass/Session";
import { ExportExcel } from "../../commonClass/ExportExcel";
import { ConfirmationModal } from "../../../customControl/ConfirmationModal";
import CustomTable from "../../../customControl/CustomTable";
import CommonFilter from "../../../customControl/CommonFilter";
import "../../../assets/css/master.css";

const CapStepper = ({ value, min, max, disabled, onChange }) => (
    <div className="d-flex align-items-center">
        <button
            type="button"
            className="border-0 rounded-2"
            style={{ width: 36, height: 36, backgroundColor: "#eef1f4", color: "#6b7280" }}
            disabled={disabled || value <= min}
            onClick={() => onChange(value - 1)}
        >
            −
        </button>
        <span className="text-center fw-medium" style={{ minWidth: 36 }}>{value}</span>
        <button
            type="button"
            className="border-0 rounded-2"
            style={{ width: 36, height: 36, backgroundColor: "#eef1f4", color: "#6b7280" }}
            disabled={disabled || value >= max}
            onClick={() => onChange(value + 1)}
        >
            +
        </button>
    </div>
);

const defaultForm = {
    VehicleCategoryId: 0,
    VehicleHeaderId: 0,
    VehicleCategory: "",
    MaxAdultCap: 1,
    MaxTotalCap: 1,
    FreeInfantsCap: 0,
    IsActive: true,
};

const VehicleCategorymaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const vehicleGroupRef = useRef(null);

    const [modalShow, setModalShow] = useState(false);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [searchvalue, setSearchValue] = useState("");
    const [searchby, setSerachBy] = useState("All");
    const [searchDisabled, setSearchDisabled] = useState(false);
    const [formError, setFormError] = useState({});
    const [vehicleGroupOption, setVehicleGroupOption] = useState([]);
    const [categoryListData, setCategoryListData] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [formValue, setFormValue] = useState({ ...defaultForm });

    const user = useSelector((store) => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const mapListItem = (obj) => {
        const IsActive = obj?.IsActive ?? obj?.isActive;
        const createdDate = obj?.CreatedDate || obj?.createdDate;
        return {
            ...obj,
            VehicleCategoryId: obj?.VehicleCategoryId ?? obj?.VehicleCategoryId ?? 0,
            VehicleHeaderId: obj?.VehicleHeaderId ?? obj?.VehicleHeaderId ?? 0,
            VehicleGroup: obj?.VehicleGroup || obj?.vehicleGroup || obj?.VehicleHeader || obj?.vehicleHeader || "",
            VehicleCategory: obj?.VehicleCategory || obj?.VehicleCategory || "",
            MaxAdultCap: obj?.MaxAdultCap ?? obj?.maxAdultCap ?? 0,
            MaxTotalCap: obj?.MaxTotalCap ?? obj?.maxTotalCap ?? 0,
            FreeInfantsCap: obj?.FreeInfantsCap ?? obj?.freeInfantsCap ?? 0,
            IsActive: IsActive,
            Active: IsActive ? "Active" : "InActive",
            createdDate,
            createdDateFormat: createdDate ? formatDate(createdDate) : "",
        };
    };

    const getVehicleGroupList = async () => {
        const response = await getAllData("/master/v1/getvehicleheaderlist");
        if (response?.status) {
            setVehicleGroupOption(response?.data ? response?.data : []);
        } else {
            setVehicleGroupOption([]);
        }
    };

    const getCategoryList = async () => {
        const response = await getAllData("/master/v1/getVehicleCategorylist");
        const list = response?.data?.map(mapListItem) || [];
        if (response?.status) {
            setCategoryListData(list);
            setFilterList(list);
        } else {
            setCategoryListData([]);
            setFilterList([]);
        }
    };

    const columns = [
        {
            name: "Vehicle Group",
            key: "VehicleGroup",
            sortable: true,
            float: "left",
            reorder: true,
            selector: (row) => row?.VehicleGroup,
        },
        {
            name: "Vehicle Category",
            key: "VehicleCategory",
            sortable: true,
            float: "left",
            reorder: true,
            selector: (row) => row?.VehicleCategory,
        },
        {
            name: "Max Adult (cap)",
            key: "MaxAdultCap",
            sortable: true,
            float: "left",
            selector: (row) => row?.MaxAdultCap,
        },
        {
            name: "Max Total (cap)",
            key: "MaxTotalCap",
            sortable: true,
            float: "left",
            selector: (row) => row?.MaxTotalCap,
        },
        {
            name: "Free Infants (cap)",
            key: "FreeInfantsCap",
            sortable: true,
            float: "left",
            selector: (row) => row?.FreeInfantsCap,
        },
        {
            name: "Active",
            key: "Active",
            sortable: true,
            float: "left",
            selector: (row) => row?.Active,
        },
        {
            name: "Create Date",
            key: "createdDateFormat",
            sortable: true,
            float: "left",
            selector: (row) => new Date(row?.createdDate),
            format: (row) => row?.createdDateFormat,
        },
        {
            name: "Edit",
            selector: (row) => (
                <button type="button" className="border-0 p-0 bg-transparent set_disableclr" disabled={!useredit}>
                    <i className="fa fa-edit" onClick={() => handleEditView("Edit", row?.VehicleCategoryId)}></i>
                </button>
            ),
        },
        {
            name: "View",
            selector: (row) => (
                <button type="button" className="border-0 p-0 bg-transparent set_disableclr">
                    <i className="fa fa-eye" onClick={() => handleEditView("View", row?.VehicleCategoryId)}></i>
                </button>
            ),
        },
    ];

    const handleChange = (name, value) => {
        setFormError({});
        setEditDisabled(true);
        setFormValue((form) => ({ ...form, [name]: value }));
    };

    const handleVehicleGroupChange = (e) => {
        setFormError({});
        setEditDisabled(true);
        setFormValue((form) => ({ ...form, VehicleHeaderId: e?.value || 0 }));
    };

    const handleCount = (name, count) => {
        setFormError({});
        setEditDisabled(true);
        setFormValue((form) => {
            const next = { ...form, [name]: count };
            if (name === "MaxAdultCap" && count > form?.MaxTotalCap) {
                next.MaxTotalCap = count;
            }
            return next;
        });
    };

    const handleIsActive = (e) => {
        if (buttonaddeditText === "Add") {
            setFormValue((form) => ({ ...form, IsActive: e }));
            setFormError({});
        } else {
            setModalShow(true);
        }
    };

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue((form) => ({ ...form, IsActive: !form?.IsActive }));
            setEditDisabled(true);
            setFormError({});
        }
        setModalShow(false);
    };

    const validation = () => {
        let status = true;
        const error = {};
        const category = formValue?.VehicleCategory?.trim() || "";

        if (!formValue?.VehicleHeaderId) {
            error.VehicleHeaderId = "Vehicle Group is required.";
            status = false;
        }
        if (!category) {
            error.VehicleCategory = "Vehicle Category is required.";
            status = false;
        } else if (!/^[A-Za-z\s.-]+$/.test(category)) {
            error.VehicleCategory = "Please enter a valid Vehicle Category.";
            status = false;
        }
        if (Number(formValue?.MaxAdultCap) < 1) {
            error.MaxAdultCap = "Max Adult must be at least 1.";
            status = false;
        }
        if (Number(formValue?.FreeInfantsCap) < 0) {
            error.FreeInfantsCap = "Free Infants cannot be less than 0.";
            status = false;
        }
        if (Number(formValue?.MaxTotalCap) < Number(formValue?.MaxAdultCap)) {
            error.MaxTotalCap = "Max Total cannot be less than Max Adult.";
            status = false;
        }

        setFormError(error);
        if (Object?.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            if (id === "VehicleHeaderId") {
                vehicleGroupRef.current?.focus();
            } else {
                document.getElementById(id)?.focus();
            }
        }
        return status;
    };

    const handleAddClick = async (e) => {
        e.preventDefault();
        if (!validation()) return;

        const statusoftoken = await verifytoken();
        if (!statusoftoken) {
            ClearLocalStorage();
            dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" });
            return;
        }

        const payload = {
            VehicleCategoryId: formValue?.VehicleCategoryId,
            VehicleHeaderId: formValue?.VehicleHeaderId,
            VehicleCategory: formValue?.VehicleCategory?.trim(),
            MaxAdultCap: Number(formValue?.MaxAdultCap),
            MaxTotalCap: Number(formValue?.MaxTotalCap),
            FreeInfantsCap: Number(formValue?.FreeInfantsCap),
            IsActive: formValue?.IsActive,
        };

        const response = await postUsersData("/master/v1/insertorupdateVehicleCategory", payload);
        if (response?.status) {
            dispatch({ type: "ALERTING", message: response?.message });
            clear();
        } else {
            dispatch({ type: "ALERTING", message: response?.message });
        }
    };

    const handleEditView = (type, id) => {
        setDisabled(type !== "Edit");
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        setEditDisabled(false);
        setSearchDisabled(true);
        setFormError({});

        const obj = categoryListData?.find((item) => item?.VehicleCategoryId === id);
        if (!obj) return;

        setFormValue({
            VehicleCategoryId: obj?.VehicleCategoryId,
            VehicleHeaderId: obj?.VehicleHeaderId,
            VehicleCategory: obj?.VehicleCategory,
            MaxAdultCap: obj?.MaxAdultCap || 1,
            MaxTotalCap: obj?.MaxTotalCap || obj?.MaxAdultCap || 1,
            FreeInfantsCap: obj?.FreeInfantsCap ?? 0,
            IsActive: !!obj?.IsActive,
        });
    };

    const clear = () => {
        setFormValue({ ...defaultForm });
        setFormError({});
        setDisabled(false);
        setEditDisabled(true);
        setSearchDisabled(false);
        setButtonAddEditText("Add");
        setSearchValue("");
        setSerachBy("All");
        getCategoryList();
    };

    function PdfExport() {
        const keys = columns?.filter((obj) => obj?.key && !obj?.omit)?.map((obj) => obj?.key);
        const pdfColumns = columns?.filter((obj) => obj?.key && !obj?.omit)?.map((obj) => obj?.name);
        const rows = categoryListData?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "VehicleCategoryMaster", "Vehicle Category Master", "l");
    }

    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => obj?.key && !obj?.omit)?.map((obj) => obj?.name);
        const fields = columns?.filter((obj) => obj?.key && !obj?.omit)?.map((obj) => obj?.key);
        ExportExcel(dispalyname, fields, categoryListData, "VehicleCategoryMaster", "VehicleCategoryMaster.xls");
    };

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                await Promise.all([getVehicleGroupList(), getCategoryList()]);
                dispatch(loaderActions.end());
            } else {
                ClearLocalStorage();
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" });
                dispatch(loaderActions.end());
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        const pagelink = user?.find((x) => x.PageLink === window.location.pathname);
        const mid = user?.find((x) => x.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate("/dashboard");
        }
        user?.filter((x) => x.MenuId === pagelink?.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);
            return obj;
        });
    }, [user]);

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Vehicle Category Master</h3>
            </div>
            <div className="container-fluid form_border py-5 mb-3">
                <form action="">
                    <div className="mb-3 mx-1">
                        <div className="row mb-3 align-items-center">
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label required mb-0">Vehicle Group</label>
                            </div>
                            <div className="col-lg-5 col-md-7 col-12">
                                <Select
                                    ref={vehicleGroupRef}
                                    id="VehicleHeaderId"
                                    className="dropdown select_dropdown"
                                    options={vehicleGroupOption}
                                    value={vehicleGroupOption?.filter((group) => group?.value === formValue?.VehicleHeaderId)}
                                    onChange={handleVehicleGroupChange}
                                    isDisabled={disabled}
                                    isSearchable
                                    placeholder="Select Vehicle Group"
                                />
                                {formError?.VehicleHeaderId && <div className="text-danger">{formError?.VehicleHeaderId}</div>}
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label required mb-0" htmlFor="VehicleCategory">Vehicle Category</label>
                            </div>
                            <div className="col-lg-5 col-md-7 col-12">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="VehicleCategory"
                                    name="VehicleCategory"
                                    value={formValue?.VehicleCategory}
                                    onChange={(e) => handleChange(e?.target?.name, VehicleCategoryRegex(e?.target?.value))}
                                    placeholder="Vehicle Category"
                                    maxLength={25}
                                    disabled={disabled}
                                />
                                {formError?.VehicleCategory && <div className="text-danger">{formError?.VehicleCategory}</div>}
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label required mb-0">Max Adult (cap)</label>
                            </div>
                            <div className="col-lg-3 col-md-4 col-12" id="MaxAdultCap">
                                <CapStepper
                                    value={formValue?.MaxAdultCap}
                                    min={1}
                                    max={100}
                                    disabled={disabled}
                                    onChange={(count) => handleCount("MaxAdultCap", count)}
                                />
                                {formError?.MaxAdultCap && <div className="text-danger">{formError?.MaxAdultCap}</div>}
                            </div>
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label required mb-0">Free Infants (cap)</label>
                            </div>
                            <div className="col-lg-3 col-md-4 col-12" id="FreeInfantsCap">
                                <CapStepper
                                    value={formValue?.FreeInfantsCap}
                                    min={0}
                                    max={100}
                                    disabled={disabled}
                                    onChange={(count) => handleCount("FreeInfantsCap", count)}
                                />
                                {formError?.FreeInfantsCap && <div className="text-danger">{formError?.FreeInfantsCap}</div>}
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label required mb-0 d-block lh-sm">Max Total (cap)</label>
                                <span className="text-muted small">(Adult + Child)</span>
                            </div>
                            <div className="col-lg-3 col-md-4 col-12" id="MaxTotalCap">
                                <CapStepper
                                    value={formValue?.MaxTotalCap}
                                    min={formValue?.MaxAdultCap}
                                    max={100}
                                    disabled={disabled}
                                    onChange={(count) => handleCount("MaxTotalCap", count)}
                                />
                                {formError?.MaxTotalCap && <div className="text-danger">{formError?.MaxTotalCap}</div>}
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <div className="col-lg-2 col-md-3 col-12">
                                <label className="col-form-label mb-0">Active</label>
                            </div>
                            <div className="col-lg-3 col-md-4 col-12">
                                <Switch
                                    onChange={handleIsActive}
                                    checked={formValue?.IsActive}
                                    className="react-switch"
                                    disabled={disabled}
                                />
                            </div>
                            <ConfirmationModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                noconfirm={() => handleConfirmation(false)}
                                yesconfirm={() => handleConfirmation(true)}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ? (
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>
                                {buttonaddeditText}
                            </button>
                        ) : (
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>
                                {buttonaddeditText}
                            </button>
                        )}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={clear}>
                            Clear
                        </button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getCategoryList}
                        setlistdata={setCategoryListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={categoryListData}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    );
};

export default VehicleCategorymaster;
